/**
 * Phonics Letter Zz — 课程数据配置
 * Story 1: 右上4单词 + 下部4句台词（英文+部分中文）
 * Story 2: 右上4单词 + 下部4句台词（英文，不要翻译）
 */

const MEDIA_BASE = '/media/phonics/zz';

export const letterDataZz = {
  letter: 'Zz',
  title: 'Phonics',
  subtitle: 'Letter Zz',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Zz.mp4`,
    poster: `${MEDIA_BASE}/cover.png`,
    startTime: 10,
    endTime: 90,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4`, cover: `${MEDIA_BASE}/image8.png`,  word: 'zebra',   wordCn: '斑马' },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4`, cover: `${MEDIA_BASE}/image9.png`,  word: 'zipper',  wordCn: '拉链' },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4`, cover: `${MEDIA_BASE}/image10.png`, word: 'zoo',     wordCn: '动物园' },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4`, cover: `${MEDIA_BASE}/image11.png`, word: 'zero',    wordCn: '零' },
  ],

  // Story sections
  storySections: [

    // Learn the Story (1) — 右上4单词 + 下部4句台词（英文+部分中文）
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      splitAt: 4,
      videos: [{ src: `${MEDIA_BASE}/video_story_1.mp4`, poster: `${MEDIA_BASE}/image13.png` }],
      lines: [
        // 右侧单词（4个）
        { en: 'Wake up', cn: '醒醒',       audioEn: `${MEDIA_BASE}/w_en_s1_wake_up.mp3`, audioCn: `${MEDIA_BASE}/w_cn_s1_wake_up.mp3` },
        { en: 'lovely',  cn: '美好的',     audioEn: `${MEDIA_BASE}/w_en_s1_lovely.mp3`,  audioCn: `${MEDIA_BASE}/w_cn_s1_lovely.mp3` },
        { en: 'jacket',  cn: '夹克',       audioEn: `${MEDIA_BASE}/w_en_s1_jacket.mp3`,  audioCn: `${MEDIA_BASE}/w_cn_s1_jacket.mp3` },
        { en: 'fancy',   cn: '漂亮的',     audioEn: `${MEDIA_BASE}/w_en_s1_fancy.mp3`,   audioCn: `${MEDIA_BASE}/w_cn_s1_fancy.mp3` },
        // 视频下方台词（4句）
        { en: 'Zebra, Zebra! Wake up!',             cn: null,                                  audioEn: `${MEDIA_BASE}/story1_en_1.mp3` },
        { en: 'What a lovely day!',                  cn: '多么美好的一天！',                    audioEn: `${MEDIA_BASE}/story1_en_2.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3` },
        { en: 'Zebra, zip up your jacket.',          cn: '拉上你的夹克拉链。',                  audioEn: `${MEDIA_BASE}/story1_en_3.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3` },
        { en: 'What a fancy zipper!',                cn: '多么漂亮的拉链啊！',                  audioEn: `${MEDIA_BASE}/story1_en_4.mp3`, audioCn: `${MEDIA_BASE}/story1_cn_4.mp3` },
      ],
    },

    // Learn the Story (2) — 右上4单词 + 下部4句台词（英文，不要翻译）
    {
      label: 'Learn the Story (2)',
      layout: 'video-left-vocab-right',
      splitAt: 4,
      videos: [{ src: `${MEDIA_BASE}/video_story_2.mp4`, poster: `${MEDIA_BASE}/image14.png` }],
      lines: [
        // 右侧单词（4个）
        { en: 'race',  cn: '赛跑',  audioEn: `${MEDIA_BASE}/w_en_s2_race.mp3`,  audioCn: `${MEDIA_BASE}/w_cn_s2_race.mp3` },
        { en: 'three', cn: '三',    audioEn: `${MEDIA_BASE}/w_en_s2_three.mp3`, audioCn: `${MEDIA_BASE}/w_cn_s2_three.mp3` },
        { en: 'two',   cn: '二',    audioEn: `${MEDIA_BASE}/w_en_s2_two.mp3`,   audioCn: `${MEDIA_BASE}/w_cn_s2_two.mp3` },
        { en: 'one',   cn: '一',    audioEn: `${MEDIA_BASE}/w_en_s2_one.mp3`,   audioCn: `${MEDIA_BASE}/w_cn_s2_one.mp3` },
        // 视频下方台词（4句，不要翻译）
        { en: "Zebra, let's go to the zoo.",   audioEn: `${MEDIA_BASE}/story2_en_1.mp3` },
        { en: 'What a nice zoo!',               audioEn: `${MEDIA_BASE}/story2_en_2.mp3` },
        { en: "Zebra, let's have a race.",      audioEn: `${MEDIA_BASE}/story2_en_3.mp3` },
        { en: 'Three, two, one, zero!',         audioEn: `${MEDIA_BASE}/story2_en_4.mp3` },
      ],
    },

  ],

  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/cover.png`,
};

export default letterDataZz;
